/**
 * RegisterStep3 - Success confirmation
 * Step 3 of 3: Success message with auto-redirect
 */

import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@/components/v2/ui/Alert';

export function RegisterStep3() {
  const { t } = useTranslation();
  return (
    <div className="register-step3 text-center space-y-4">
      <div className="flex justify-center">
        <CheckCircle className="w-16 h-16 text-green-500" aria-hidden="true" />
      </div>

      <Alert variant="success">
        <div className="space-y-2">
          <p className="font-semibold">{t('auth.step3Title')}</p>
          <p className="text-sm">{t('auth.confirmEmail')}</p>
        </div>
      </Alert>

      <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
        <p>
          {t('auth.confirmEmailSent')}
        </p>
        <p className="text-xs">
          Klicke auf den Link in der Email, um deinen Account und Workspace zu aktivieren.
        </p>
      </div>
    </div>
  );
}
